import React, { useEffect, useState } from 'react';
import Error from 'next/error';
import checkServer from '@/utils/checkServer';

interface WithServerCheckProps {
  children: React.ReactNode;
}

const WithServerCheck: React.FC<WithServerCheckProps> = ({ children }) => {
  const [fetchError, setFetchError] = useState<string | null>(null);
  const apiConnectionsString = process.env.NEXT_PUBLIC_API_CONNECTION_STRING
  
  useEffect(() => {
    async function fetchData() {
      try {
        const result = await checkServer(apiConnectionsString || "");
        if (result === true) {
            return
        } else {
            if (process.env.NODE_ENV === "development") {
                console.log(result);
            }
        }
      } catch (error: any) {
        if (process.env.NODE_ENV === "development") {
            console.error(error.message);
        }
        setFetchError(`Endpoint not available or Server error occurred`);
      }
    }
    fetchData();
  }, [apiConnectionsString]);

  if (fetchError) {
    return <Error statusCode={500} title={fetchError} />;
  }

  return <>{children}</>;
};

export default WithServerCheck;
